import { ClientWalletRoleEnum } from '@tassat/common-definitions';
import React from 'react';

import { AddOn } from './screensContent/addOn/addOn';
import { Decline } from './screensContent/declinePledge';
import { Approval } from './screensContent/pledgeApproval';
import { Reclaim } from './screensContent/reclaim/reclaim';
import { Release } from './screensContent/release/release';
import { PledgeDetailsModalScreensProps } from './types';

export default function PledgeDetailsModalScreens(props: PledgeDetailsModalScreensProps) {
    const { modalScreen, userPledgorAccount, userPledgeeAccount } = props;

    const relevantAccount = modalScreen === 'addOn' ?
        userPledgorAccount
        : (userPledgorAccount ?? userPledgeeAccount);

    const approvalNeeded = relevantAccount?.ClientRoleId === ClientWalletRoleEnum.MAKER ||
        relevantAccount?.ClientRoleId === ClientWalletRoleEnum.APPROVER;

    switch (modalScreen) {
        case 'addOn':
            return <AddOn approvalNeeded={approvalNeeded} />;
        case 'release':
            return <Release approvalNeeded={approvalNeeded} />;
        case 'reclaim':
            return <Reclaim approvalNeeded={approvalNeeded} />;
        case 'approve':
            return <Approval />;
        case 'decline':
        case 'cancel':
            return <Decline />;
        default:
            return null;
    }
}